import { Modal, Tooltip } from 'antd';
import React from 'react';
import Slider from 'react-slick'
import { RichText } from 'prismic-reactjs';
import Exclamacion from '../../assets/images/exclamation.svg';
import Red from '../../assets/images/semaforo-rojo.svg';
import Yellow from '../../assets/images/semaforo-amarillo.svg';
import Green from '../../assets/images/semaforo-verde.svg';

// @styles 
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function ModalStole({ info, values, onClose }) {
    const settingsSlider = {
        dots: false,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        slickNext: true,
        slickPrev: true,
        responsive: [
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            }
        ]
    }

    const _onCancel = () => {
        onClose();
    }

    const semaforo = { Rojo: Red, Amarillo: Yellow, Verde: Green };

    return info && (
        <Modal
            title=""
            visible={true}
            footer=''
            onCancel={_onCancel}
            wrapClassName='modal-home'
        >
            <div className='modal-home-content'>
                <div className='modal-home-content-left'>
                    <div className='modal-home-content-left__body'>
                        <div className='modal-home-content-left__body-title'>
                            {info.modalicon && info.modalicon.url && (
                                <img src={info.modalicon.url} alt={info.modaltitle} />
                            )}
                            <p>{info.modaltitle || ''}</p>
                        </div>
                        <p className='modal-home-content-left__body-subtitle'>{info.modaldescription || ''}</p>
                        <ul className='modal-home-content-left__body-list'>

                            {info.modalitems && info.modalitems.length > 0 && info.modalitems.map((modalitem) =>
                                modalitem && modalitem.text && (<li>
                                    <em className='fal fa-check' />
                                    <div className='modal-home-content-left__body-list-description'>
                                        <strong>{modalitem.text.split('\n')[0]}</strong>
                                        <p> {modalitem.text.split('\n')[1]} </p>
                                    </div>
                                </li>)
                            )}
                        </ul>
                    </div>
                </div>
                <div className='modal-home-content-right half'>
                    {info.modalsidecontent && (<div className='modal-home-content-right__body'>
                        <div className='modal-home-content-right__body-title'>
                            <RichText
                                render={info.modalsidecontent}
                            />
                        </div>
                    </div>)}
                </div>
            </div>

            <div className='modal-home-footer'>
                {info.bottomcontent && info.bottomcontent.length > 0 && (<div className='modal-home-footer__left'>
                    <div className='modal-home-footer__left-title'>
                        <img src={Exclamacion} alt='Imagen exclamación sabias que' />
                        <strong>{info.bottomcontent[0].text || ''}</strong>
                    </div>
                    <div className='modal-home-footer__left-description'>
                        <p>{info.bottomcontent[1].text || ''}</p>
                        <div className='modal-home-footer__left-description-source'>
                            {info.bottomcontent.map((btnCont, index) =>
                                index > 1 && (<>
                                    {btnCont.spans[0] && btnCont.spans[0].data && btnCont.spans[0].data.url ?
                                        (<a href={btnCont.spans[0].data.url} target="_blank" rel="noreferrer">
                                            {btnCont.text || ''}
                                        </a>) : <p>{btnCont.text || ''}</p>}
                                </>)
                            )}
                        </div>
                    </div>
                </div>)}
                <div className='modal-home-footer__right'>
                    <div className='modal-home-footer__right-container'>
                        <Slider {...settingsSlider}>
                            {values && values.length > 0 && values.map((value) =>
                                <div className='slider__item'>
                                    <img src={semaforo[value.semaforo]} className='slider__item-img' alt={value.entidad || ''} />
                                    <div className='slider__item-description'>
                                        <Tooltip title={value.entidad.length > 15 ? value.entidad : ''} color={'#FFF'}><p className='slider__item-description-title'>{value.entidad || ''}</p></Tooltip>
                                        <div className='slider__item-description-incidents'>
                                            <p>INCIDENTES</p>
                                            <p>{value.incidentes || ''}</p>
                                        </div>
                                        <div className='slider__item-description-population'>
                                            <p>POBLACIÓN</p>
                                            <p>{value.poblacion || ''}</p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </Slider>
                    </div>
                </div>
            </div>
        </Modal>
    )
}